<icc-list [searchable]="true" [items]="items"
          [itemTemplate]="'itemImgTitle'"
          itemImgHeight="medium"
          (select)="selectItem($event)"
          [selected]="selectedId"
          (showInfo)="showInfo($event)"
></icc-list>
